import fetch from '@/utils/request'

const request = (rest = {}) => fetch({ ...rest, privateFlag: true })
export default {
  getDrugList(data) {
    return request({
      url: `/emi/drug/list`,
      method: 'POST',
      data
    })
  },
  // 药品剂型列表
  getDosageFormList(data) {
    return request({
      url: `/emi/drug/dosageFormList`,
      method: 'POST',
      data
    })
  },
  // 药品类型列表
  getDrugTypeList(data) {
    return request({
      url: `/emi/drug/typeList`,
      method: 'POST',
      data
    })
  },
  // 添加药品
  drugAdd(data) {
    return request({
      url: `/emi/drug/add`,
      method: 'POST',
      data
    })
  },
  // 编辑药品
  drugUpdate(data) {
    return request({
      url: `/emi/drug/update`,
      method: 'POST',
      data
    })
  },

  // 查询药品详情
  getDrugInfo(data) {
    return request({
      url: `/emi/drug/getDrugInfo`,
      method: 'POST',
      data
    })
  },

  // 删除药品
  drugDelete(data) {
    return request({
      url: `/emi/drug/delete`,
      method: 'POST',
      data
    })
  },
  // 添加药品包装规格
  addPacking(data) {
    return request({
      url: `/emi/drug/addPacking`,
      method: 'POST',
      data
    })
  },
  // 添加药品包装规格
  deletePacking(data) {
    return request({
      url: `/emi/drug/deletePacking`,
      method: 'POST',
      data
    })
  },
  // 修改药品包装规格
  updatePacking(data) {
    return request({
      url: `/emi/drug/updatePacking`,
      method: 'POST',
      data
    })
  },
  // 根据商品id或通用名 模糊搜索
  fuzzySearch(data) {
    return request({
      url: `/emi/drug/fuzzySearch`,
      method: 'POST',
      data
    })
  },
  // 根据药品信息查询关联的说明书数量
  drugRelateNum(data) {
    return request({
      url: `/emi/drugBook/drugRelateNum`,
      method: 'POST',
      data
    })
  },
  // 获取当前用户最近的历史版本
  getRecentHistoryVersion(data) {
    return request({
      url: `/emi/drugBook/getRecentHistoryVersion`,
      method: 'POST',
      data
    })
  },
  // 清除用户最近的快照信息
  deleteRecentHistoryVersion(data) {
    return request({
      url: `/emi/drugBook/deleteRecentHistoryVersion`,
      method: 'POST',
      data
    })
  },
  // 平台药品重复校验
  postCommonDrugCheckExist(data) {
    return request({
      url: `/emi/drug/checkExist`,
      method: 'POST',
      data
    })
  },
  // 药品包装验重接口
  postCheckPackingExist(data) {
    return request({
      url: `/emi/drug/checkPackingExist`,
      method: 'POST',
      data,
      hideLoading: true
    })
  },
  // 根据批准文号查询国家药品信息
  getNationalDrugInfo(data) {
    return request({
      url: `/emi/drug/getNationalDrugInfo`,
      method: 'POST',
      data
    })
  },
  // 企业下拉列表
  getDrugCompanyList(data) {
    return request({ url: `/emi/drug/companyList`, method: 'POST', data })
  },
  // 药品配置二维码规则
  setDrugQrRule(data) {
    return request({ url: `/emi/drug/qrRule`, method: 'POST', data })
  }
}
